export interface UploadedFile {
  id: string;
  progress: number;
  isUploaded: boolean;
  file: File;
  sasUrl?: string;
  controller: AbortController;
}

export const getFileIdFromName = (name: string): string => {
  const id = name.split('_').shift();
  if (id) {
    return id;
  }

  throw new Error(`The file name ${name} does not contain a valid file id!`);
};

export const getFormattedFileName = (fileName: string): string => {
  const name = fileName.split('_').splice(1).join('_');
  if (name) {
    return name;
  }

  throw new Error(`The file name ${name} does not contain a valid file name!`);
};
